// React
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import lodash from 'lodash';
import axios from 'axios';

// MUI Core
import {
  Paper,
  Typography,
  Button,
  Chip,
  Grid,
  Avatar,
  Collapse,
  TextField
} from '@material-ui/core';

// MUI Icons - Public/Private Chip
import DraftIcon from '@material-ui/icons/Create';
import PublicIcon from '@material-ui/icons/Public';
import SharedIcon from '@material-ui/icons/People';
import OnlyMeIcon from '@material-ui/icons/Lock';
import ShareIcon from '@material-ui/icons/Share';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import ChatBubbleOutlineRoundedIcon from '@material-ui/icons/ChatBubbleOutlineRounded';
import ChatBubbleRoundedIcon from '@material-ui/icons/ChatBubbleRounded';
import ModeCommentOutlinedIcon from '@material-ui/icons/ModeCommentOutlined';


// MUI Lab
import TimelineContent from '@material-ui/lab/TimelineContent';

// Modal
import EditTwoTone from '@material-ui/icons/EditTwoTone';
import Modal from '../../../../../../Components/Common/FixedModal/index';

// Constants
import { MEMORIES_BASE_URL } from '../../../../../../constants/apiRoutes';

// Styled Components
import { GroupContentCardStyles } from '../ContentCards';

// Carousel
import { Carousel } from '../../../../../Pages/ViewMemory/Carousel/Carousel';

// Sharing Modal
import { ShareModal } from '../../../../../Pages/CreateMemory/ShareModal/ShareModal';
import styled from 'styled-components';
import { Divider } from '../../../../../Divider/Divider';
import GroupComment from './GroupComment/GroupComment';

export function GroupMemoryCard({
  _id,
  createdAt,
  date,
  dateAge,
  dateType,
  memory: description,
  category,
  images,
  isDraft,
  isPublic,
  privacySetting,
  taggedEmails,
  tempImages,
  title,
  updatedAt,
  user,
  video,
  tempVideo,
  voice,
  isHighlighted,
  tempVoice,
  author,
  authorImage,
  viewingFriendsMemory = false,
  isCompetition = false,
  formattedDate,
  noLogin = false,
  profile,
  customTheme,
  groupMemberStatus,
  openEditMemoryFunc,
  memoryType,
  userId,
  ...props
}) {
  // Collect memory details
  const Heart = ({
    isActive,
    onClick = () => {},
    animationTrigger = "click",
    animationScale = 1.05,
    animationDuration = 0.05,
    inactiveColor = "black",
    activeColor = "red",
    className,
    style
  }) => {
    return /*#__PURE__*/React.createElement(Svg, {
      onClick: () => onClick(),
      viewBox: "0 0 17 17",
      className: className,
      animationTrigger: animationTrigger,
      animationDuration: animationDuration,
      animationScale: animationScale,
      style: {
        fill: isActive ? activeColor : "transparent",
        stroke: isActive ? "transparent" : inactiveColor,
        strokeWidth: "1px",
        ...style
      },
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
    }));
  }
  const Svg = styled.svg`cursor: pointer;${props => {
    if (props.animationTrigger === "hover") return `transition: transform ${props.animationDuration}s; &:hover { transform: scale(${props.animationScale});}`;else if (props.animationTrigger === "click") return `transition: transform ${props.animationDuration}s; &:active { transform: scale(${props.animationScale});}`;else if (props.animationTrigger === "both") return `transition: transform ${props.animationDuration}s; &:hover { transform: scale(${props.animationScale});} &:active { transform: scale(${Math.pow(props.animationScale, 2)});}`;
  }});`;

  const memory = {
    _id,
    createdAt,
    date,
    dateAge,
    dateType,
    description,
    images,
    isDraft,
    isPublic,
    privacySetting,
    taggedEmails,
    tempImages,
    title,
    updatedAt,
    user,
    video,
    tempVideo,
    voice,
    tempVoice,
    memoryType,
  };
  // Track if memory privacy status is being edited
  const [privacyState, setPrivacyState] = useState(privacySetting);
  const [isEditingSharing, setIsEditingSharing] = useState(false);
  const [clamped, setClamped] = useState(true);
  const [reactions, setReactions] = useState([]);
  const [comments, setComments] = useState([]);
  const [showClampButton, setShowClampButton] = useState(true);
  const [commentMessage, setCommentMessage] = useState('');
  const [showComments, setShowComments] = useState(false);
  const containerRef = useRef(null);
 

  // Convert legacy privacy setting to new privacy setting string
  const getPrivacySettingString = () => {
    switch (true) {
      case privacyState !== undefined:
        return privacyState;
      case isDraft === true:
        return undefined;
      case isPublic === false:
        return 'Friends & Family';
      case isPublic === true:
        return 'Public';
      default:
        break;
    }
  };

  useEffect(() => {
    setPrivacyState(privacySetting);
  }, [memory, privacySetting]);

  useEffect(() => {
    getReaction();
    getComments();
  }, []);

  const getReaction = async () => {
    const { data } = await axios.get(`/api/group-memory-reaction/${_id}`);
    if (data) {
      setReactions(data);
    }
  };

  const getComments = async () => {
    const { data } = await axios.get(`/api/group-memory-comments/${_id}`)
    if (data) {
      setComments(data);
    }
  };

  const postComment = async () => {
    const { data } = await axios.post('/api/group-memory-comments', {
      text: commentMessage,
      userId,
      groupMemoryId: _id,
    })
    if (data) {
      await getComments();
    }
  }

  const postReaction = async () => {
    const { data } = await axios.post('/api/group-memory-reaction', {
      groupMemoryId: _id,
      userId,
    });
    if (data) {
      await getReaction();
    }
  };

  const deleteReaction = async reactionId => {
    const { data } = await axios.delete(
      `/api/group-memory-reaction/${reactionId}`,
    );
    if (data) {
      await getReaction();
    }
  };
  // useEffect(() => {
  //   const hasClamping = (el) => {
  //     const { clientHeight, scrollHeight } = el;
  //     return clientHeight !== scrollHeight;
  //   };

  //   const checkButtonAvailability = () => {
  //     if (containerRef.current) {
  //       // Save current state to reapply later if necessary.
  //       const hadClampClass = containerRef.current.classList.contains("clamp");
  //       // Make sure that CSS clamping is applied if aplicable.
  //       if (!hadClampClass) containerRef.current.classList.add("clamp");
  //       // Check for clamping and show or hide button accordingly.
  //       setShowClampButton(hasClamping(containerRef.current));
  //       // Sync clamping with local state.
  //       if (!hadClampClass) containerRef.current.classList.remove("clamp");
  //     }
  //   };

  //   const debouncedCheck = lodash.debounce(checkButtonAvailability, 50);

  //   checkButtonAvailability();
  //   window.addEventListener("resize", debouncedCheck);

  //   return () => {
  //     window.removeEventListener("resize", debouncedCheck);
  //   };
  // }, [containerRef])

  // Content rendering
  const renderPrivacySetting = () => {
    const chipProps = {
      className: 'privacySettingChip',
      color: 'primary',
      variant: 'outlined',
      icon: false,
      label: false,
      onClick: () => setIsEditingSharing(true),
    };
    // Make non-clickable if displaying a friend's memory
    if (viewingFriendsMemory) {
      chipProps.clickable = false;
      chipProps.onClick = () => {};
    }
    // Private Memory
    if (privacyState === 'Only Me') {
      chipProps.label = 'Only Me';
      chipProps.icon = <OnlyMeIcon />;
      chipProps.color = 'default';
    }
    // Private Memory
    if (privacyState === 'Specific Groups') {
      chipProps.label = 'Specific Groups';
      chipProps.icon = <SharedIcon />;
      chipProps.color = 'default';
    }
    // Public Memory
    if ((!privacyState && isPublic) || privacyState === 'Public') {
      chipProps.label = 'Public';
      chipProps.icon = <PublicIcon />;
      chipProps.color = 'primary';
    }
    // Friends & Family
    if ((!privacyState && !isPublic) || privacyState === 'Friends & Family') {
      chipProps.label = 'Friends & Family';
      chipProps.icon = <SharedIcon />;
      chipProps.color = 'default';
    }
    // Draft Memory
    if (isDraft) {
      chipProps.label = 'Draft';
      chipProps.icon = <DraftIcon />;
      chipProps.color = 'default';
      chipProps.onClick = () => {};
    }

    return <Chip {...chipProps} />;
  };
  const renderShortenedText = (text, length) =>
    length < text?.length ? `${text?.slice(0, length)}...` : text || null;
  const renderCTAButtonText = () =>
    isDraft ? `Complete This Memory` : `View This Memory`;

  const RenderReadMoreDescription = () => {
    if (description.length > 0) {
      return (
        <>
          <Typography
            style={{whiteSpace: 'pre-line'}}
          >
            {description}
          </Typography>
        </>
      );
    }
    return <></>;
  };

  const renderShareModal = () => (
    <Modal
      isShowing={isEditingSharing}
      hide={() => setIsEditingSharing(false)}
      closeAfterTransition
      hideBackground
    >
      <ShareModal
        className="modalContents"
        memory={{ ...memory, privacySetting: getPrivacySettingString() }}
        setPrivacyStateFunc={setPrivacyState}
        closeFunc={() => setIsEditingSharing(false)}
      />
    </Modal>
  );

  const handleShowMoreClick = () => setClamped(!clamped);

  return (
    <GroupContentCardStyles {...props}>
      {isEditingSharing && renderShareModal()}
      <TimelineContent className="cardWrapper">
        <Paper
          elevation={1}
          className="groupCard"
          style={{border:'solid 0.5px #FCF8F7', borderRadius:'0px'}}
          // style={{ border: `3px solid ${customTheme.palette.primary.main}` }}
        >

          <div className="cardContentWrapper" >
            <Grid container spacing={1} >
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
              
               
                }}
              >
                <Avatar
                  src={
                    authorImage?.imagePath || ''
                  }
                  alt="Your profile avatar"
                
                  style={{
                    maxHeight: '100%',
                    maxWidth: '100%',
                    height: '50px',
                    width: '50px',
                    backgroundColor: customTheme.palette.primary.light,
                    color: customTheme.palette.primary.contrastText, 
                    textTransform: 'capitalize'
                  }}
                >
                  {author?.name[0]}
                </Avatar>
                {author && author?.name && (
                    <p style={{fontSize:'0.8rem', width: 'full', fontWeight:'600', marginTop:'0.5rem', textAlign:'center',textTransform: 'capitalize'}}> {author?.name}</p>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={10}
                md={10}
               
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div>
                  <Typography className="title" variant="h6" component="h1" style={{textTransform: 'capitalize'}}>
                    {title}
                  </Typography>
                
                  <Typography>{formattedDate}</Typography>
                </div>
              
              </Grid>
            </Grid>
          </div>
          <div className="groupCardMediaWrapper">
            <Carousel {...memory} />
          </div>
          <div className="contentWrapper">
            <Typography className="description">
              {/* {description}  */}
              {/* render read more component */}
              <RenderReadMoreDescription />
            </Typography>
            {/* <Typography variant="body1" color="textSecondary">
              {formattedDate}
            </Typography> */}
           
          </div>
          {/* {userId && userId.length > 0 && ( */}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginRight: '2rem', paddingBottom:'1rem', paddingLeft:'1rem' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ width: "1.5rem", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Heart 
                    disabled={!userId}
                    isActive={
                      reactions.filter(reaction => reaction.userId === userId)
                        .length > 0
                    }
                    onClick={async () => {
                      const hasReacted = reactions.filter(
                        reaction => reaction.userId === userId,
                      );
                      if (hasReacted && hasReacted.length > 0) {
                        await deleteReaction(hasReacted[0]?._id);
                      } else {
                        await postReaction();
                      }
                    }}
                  
                    animationScale={1.2}
                    animationTrigger="both"
                    animationDuration={0.2}
                    className={`heartContainer${reactions.filter(reaction => reaction.userId === userId).length > 0 ? ' active' : ''}`}
                  />
                  {reactions.length > 0 &&
                    <Typography style={{fontSize:'0.7rem'}}>{reactions.length > 99 ? '99+' : reactions.length}&nbsp;{reactions.length === 1 ? 'Like' : 'Likes'}</Typography>
                  }
                </div>
                <div style={{ marginLeft: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                  {showComments ? (
                    <ModeCommentOutlinedIcon
                      color='black' 
                      onClick={() => setShowComments(!showComments)}
                      style={{
                        cursor: 'pointer'
                        
                      }}
                    />
                  ) : (
                    <ModeCommentOutlinedIcon
                      color='black' 
                      onClick={() => setShowComments(!showComments)}
                      style={{
                        cursor: 'pointer'
                      }}
                    />
                  )}
                  {comments.length > 0 &&
                    <Typography style={{fontSize:'0.7rem'}}>{comments.length > 9 ? '9+' : comments.length}&nbsp;{comments.length === 1 ? 'Comment' : 'Comments'}</Typography>
                  }
                </div>
              </div>
              {groupMemberStatus === 'owner' ||
                groupMemberStatus === 'admin' ? (
                  <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => openEditMemoryFunc(memory)}
                    >
                      <EditTwoTone
                        style={{ marginRight: '0.25rem', fontSize: '1rem' }}
                      />
                      Edit
                    </Button>
                  </div>
                ) : (
                  <></>
              )}
            </div>
          {/* )} */}
          <Collapse in={showComments}>
            <Grid container spacing={1} style={{ padding: '0rem 1rem 1rem 1rem' }}>
              <Grid item xs={12}>
                <Typography variant="h5">Comments</Typography>
              </Grid>
              {/* text field */}
              <Grid item xs={12}>
              {userId && userId.length > 0 && (
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={9}>
                    <TextField
                      value={commentMessage}
                      onChange={(text) => setCommentMessage(text.target.value)}
                      variant='standard'
                      fullWidth
                      placeholder='Add comment'
                      inputProps={{ maxLength: 100 }}
                    />
                    {commentMessage.length > 0 && (
                      <Typography>
                        <span style={{ color: 'var(--neutral-mist)', fontSize: '0.7rem'}}>
                          {commentMessage.length}/100 Characters
                        </span>
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      color="primary"
                      variant="contained"
                      fullWidth
                      style={{ maxWidth: window.innerWidth < 600 ? '40%' : '100%', maxHeight: '2.5rem' }}
                      disabled={commentMessage.length === 0}
                      onClick={async () => {
                        await postComment();
                        setCommentMessage('');
                      }}
                    >
                      Comment
                    </Button>
                  </Grid>
                </Grid>
                )}
              </Grid>
              
              {/* comment list */}
              <Grid item xs={12}>
                <Grid container spacing={0} style={{ maxHeight: '200px', overflow: 'scroll' }}>
                  {comments.map((comment, i) => (
                    <Grid item xs={12}>
                      <GroupComment 
                        comment={comment} 
                        userId={userId} 
                        groupMemberStatus={groupMemberStatus}
                        getComments={async () => await getComments()}
                        customTheme={customTheme}
                      />
                      {(i+1) !== comments.length && (
                        <Divider />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </TimelineContent>
    </GroupContentCardStyles>
  );
}

GroupMemoryCard.propTypes = {
  // Memory props
  /**
   * The unique ID of this memory
   */
  _id: PropTypes.string,
  /**
   * The date this memory was created
   */
  createdAt: PropTypes.string,
  /**
   * The date this memory happened
   */
  date: PropTypes.string,
  /**
   * How old the user remember being when this memory happened (used only if `dateType` is set to `age`)
   */
  dateAge: PropTypes.number,
  /**
   * The type of date display used for this memory (`full` if the user has specified an exact date, `age` if the user has specified how old they remember being when this memory happened)
   */
  dateType: PropTypes.oneOf(['full', 'age']),
  /**
   * The user's description of this memory
   */
  description: PropTypes.string,
  /**
   * An array of images uploaded for this memory, each element being an object with a unique `_id` and `imagePath`
   */
  images: PropTypes.arrayOf({
    _id: PropTypes.string,
    imagePath: PropTypes.string,
  }),
  /**
   * Is this memory unfinished / unpublished / draft status?
   */
  isDraft: PropTypes.bool,
  /**
   * Is this memory shared publicly?
   */
  isPublic: PropTypes.bool,
  /**
   * An array of user email addresses which were tagged in this memory. Can be left blank if no other users were tagged.
   */
  taggedEmails: PropTypes.arrayOf(PropTypes.string),
  /**
   * An array of images uploaded for this memory, where each `imagePath` provides a direct URL to view the image source, authenticated with a token
   */
  tempImages: PropTypes.arrayOf({
    _id: PropTypes.string,
    imagePath: PropTypes.string,
  }),
  /**
   * The title of this memory
   */
  title: PropTypes.string,
  /**
   * A date specifying when the memory was last updated
   */
  updatedAt: PropTypes.string,
  /**
   * The user account that created this memory
   */
  user: PropTypes.string,
  /**
   * The video uploaded for this memory (provided as a path, can be blank)
   */
  video: PropTypes.string,
  /**
   * The voice recording uploaded for this memory (provided as a path, can be blank)
   */
  voice: PropTypes.string,

  // Other props

  /**
   * Provide a function to open the privacy setting modal/page for the current memory shown
   */
  openPrivacySettingsFunc: PropTypes.func,
  /**
   * Provide a function to open the sharing modal / navigate to the sharing page
   */
  shareFunc: PropTypes.func,
  /**
   * Should this card be highlighted?
   */
  isHighlighted: PropTypes.bool,
};
GroupMemoryCard.defaultProps = {
  // Memory
  _id: undefined,
  title: undefined,
  date: undefined,
  dateType: 'full',
  dateAge: undefined,
  description: undefined,
  user: undefined,
  isDraft: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  isPublic: false,
  taggedEmails: undefined,
  images: undefined,
  tempImages: undefined,
  voice: undefined,
  video: undefined,
  // Other props
  openPrivacySettingsFunc: () => {},
  shareFunc: () => {},
  isHighlighted: false,
};
